/**
 * Application status enum - represents the different states of a member application
 */
export enum ApplicationStatus {
  DATA_CHANGE = 'DATA_CHANGE',
  MEMBER_APPLIED = 'MEMBER_APPLIED',
  COMMUNITY_DECLINED = 'COMMUNITY_DECLINED',
  COMMUNITY_ACCEPTED = 'COMMUNITY_ACCEPTED',
  CONTRACTS_DONE = 'CONTRACTS_DONE'
}

/**
 * Application type enum - represents the type of application
 */
export enum ApplicationType {
  FIRST_APPLICATION = 'FIRST_APPLICATION',
  MEMBER_CHANGE = 'MEMBER_CHANGE'
}

/**
 * Member type enum - represents whether the member is a private person or a company
 */
export enum MemberType {
  PRIVATE = 'private',
  COMPANY = 'company'
}
